import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { AbstractApiController } from './abstract-api-controller';
import { ProfileResponseInterface } from '../model/response/profile-response.interface';

@Injectable()
export class AuthApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public getProfile(accessToken) {
    return this.http.get<ProfileResponseInterface>(
      this.baseUrl + '/api/cf/profile?access_token=' + accessToken
    );
  }
}
